import styled from 'styled-components';
import { Stack, Checkbox } from '@fluentui/react';
import { FontIcon } from '@fluentui/react/lib/Icon';
import Input from '../../../../../common/ui/input';

type Props = {
	hasPix?: boolean;
};

export const Container = styled(Stack)<Props>`
	display: flex;
	width: 100%;
	max-width: 300px;
	border-radius: 2px;
	border: solid 1px #c5c1bf;
	min-height: 368px;
	margin-top: 10px;
	opacity: ${({ hasPix }) => (hasPix ? '1' : '0.6')};
`;

export const CardHeader = styled.div`
	display: flex;
	align-items: center;
	border-bottom: solid 1px rgb(243, 242, 241);
	padding: 14px 16px;
	position: relative;
`;

export const HeaderText = styled.div`
	display: flex;
	margin: 0 auto;
	align-items: center;
`;

export const Icon = styled(FontIcon)`
	font-size: 18px;
	margin-right: 10px;
`;

export const CheckboxButton = styled(Checkbox)`
	position: absolute;
	left: 12px;
`;

export const ValidDate = styled.div``;

export const CardBody = styled.div`
	padding: 14px 16px;
	display: flex;
	flex-direction: column;
	gap: 5px;
	padding-bottom: 50px;
`;

export const Field = styled(Input)``;

export const PixIcon = styled.img`
	max-width: 18px;
	margin-right: 10px;
`;
